document.addEventListener('alpine:init', () => {
  Alpine.data('okendoReviews', (productId) => ({
    rating: 0,
    outOf: 5,
    blackStars: 5,
    hasStars: false,
    reviewCountText: "",
    init() {
      const template = document.querySelector(`[data-okendo-snippet="${productId}"]`);
      const ratingEl = template.content.querySelector(".okeReviews-starRating > .okeReviews-a11yText");
      const reviewCountEl = template.content.querySelector(".okeReviews-reviewsSummary-ratingCount > span[aria-hidden=true]");

      if (ratingEl) {
        const ratingText = ratingEl.innerHTML;
        const reviewCountText = reviewCountEl.innerHTML; // use the shorter version instead
        const [rating, outOf] = getNumbersFromText(ratingText);

        this.hasStars = true;
        this.rating = Math.round(rating); // TODO: handle 4.5/4.9 later
        this.outOf = outOf;
        this.blackStars = outOf - this.rating;
        this.reviewCountText = reviewCountText;
      } else {
        this.hasStars = false;
        this.rating = 0;
        this.outOf = 0;
        this.blackStars = 0;
      }
    }
  }))

// taken from https://stackoverflow.com/questions/58663230/regex-matching-multiple-numbers-in-a-string
  const getNumbersFromText = (text) => {
    const regex = /-?\d(?:[,\d]*\.\d+|[,\d]*)/g;

    let match;
    const numbers = [];

    while ((match = regex.exec(text)) !== null) {
      if (match.index === regex.lastIndex) { // This is necessary to avoid infinite loops with zero-width matches
        regex.lastIndex ++;
      }

      match.forEach((match, groupIndex) => {
        numbers.push(parseFloat(match));
      });
    }

    return numbers;
  }
});